<template>
    <span>
        <b-button @click="notesOpen = !notesOpen" :variant="variant" class="mr-2">
            <i class="fa-regular fa-clipboard-list fa-lg fa-fw"></i>
        </b-button>
        <div class="notes-display" v-if="notesOpen">
            <NotesModule ref="notes" :order_id ="order_id" :customer_id="customer_id" :user="user"></NotesModule>
        </div>
    </span>
</template>

<script>
    import NotesModule from './NotesModule'
    export default {
        name: 'NotesPopup',
        props: {
            customer_id: Number,
            order_id: Number,
            user: String,
            variant: String,
        },
        components: {
            NotesModule,
        },
        data() {
            return {
                notesExpand: false,
                notesOpen: false,
            };
        },
        mounted(){
            this.notesOpen = false; //having notes open for a frame forces vue js to load, otherwise its lazy loading and never loads
        },
        computed: {
            newNoteValue() {
                return this.newNote != '';
            },
            isValidLookup(){
                return (this.order_id || this.order_id === 0) && (this.customer_id || this.customer_id === 0);
            },
            isLoading(){
                //console.log(this.$refs,'ref');
                return this.$refs.notes.isLoading;
            }
        },
        methods: {
            openNotesWidget() {
                this.notesOpen = !this.notesOpen;
            },
            expandNotes() {
                this.notesExpand = !this.notesExpand;
            },
            closeNotes() {
                this.notesOpen = !this.notesOpen;
                this.cancelNote();
            },
            cancelNote() {
                this.$refs.notes.newNote = '';
                this.$refs.notes.creatingNote = false;
            },
        }
    };
</script>

<style scoped>
    .notes-wrapper {
        bottom: 24px;
        right: 24px;
    }
    .notes-display{
        bottom: 24px;
        right: 24px;
        position: fixed;
        z-index: 999;
        min-width:380px;
        box-shadow: 0 -5px 12px -3px #888;
    }
    .notes-toggle-btn {
        box-shadow: 0 4px 10px -4px #333;
    }

    @keyframes show {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

</style>
